module.exports = __webpack_public_path__ + "img/032.6337f3d7.png";